import { checkAcl } from 'components/acl';

export const isBoxCreateAllowed = (
  agreement: Oneflow.Agreement,
) => checkAcl(agreement.acl, 'agreement:box:create');
